import React, {FC} from "react";

export const TjeckoLogo: FC = () => {
    return <span className="block text-6xl font-[500] text-primary-800 font-roboto w-full text-center">TJ€CKO</span>
}